export default __webpack_public_path__ + "static/media/leagueBgHeader.903363ea.svg";